export { ProductPlacementComponent } from '../components/product-placement/product-placement.component';
